<template>
<div v-if="jurisdictions">
    <form-input label="State" v-model="formData.state" :errors="errors.state" type="select" :options="stateOptions" />

    <form-input label="City" v-model="formData.city" :errors="errors.city" type="select" :options="cityOptions" :disabled="cityOptions.length < 1" />
    <form-input label="County" v-model="formData.county" :errors="errors.county" type="select" :options="countyOptions" :disabled="countyOptions.length < 1" />
    <form-input label="School District" v-model="formData.school_district" :errors="errors.school_district" type="select" :options="schoolDistrictOptions" :disabled="schoolDistrictOptions.length < 1" />
</div>
</template>

<script>
import FormMixin from '@/mixins/Form'

export default {
    mixins: [FormMixin, ],
    computed: {
        stateOptions() {
            const result = []
            this.jurisdictions.filter(j => j.type == 'state').forEach(j => {
                result.push({text: j.name, value: j.id})
            })

            result.sort((a, b) => a.text.localeCompare(b.text))
            return result
        },
        currentState() {
            if (!this.jurisdictions) {return null}
            return this.jurisdictions.find(j => ((j.type == 'state') && (j.id == this.formData.state)))
        },
        cityOptions() {
            const result = []
            if (!this.currentState) {return []}

            this.jurisdictions.filter(j => ((j.type == 'city') && (j.parent_id == this.currentState.id))).forEach(j => {
                result.push({text: j.name, value: j.id})
            })

            result.sort((a, b) => a.text.localeCompare(b.text))
            return result
        },
        countyOptions() {
            const result = []
            if (!this.currentState) {return []}

            this.jurisdictions.filter(j => ((j.type == 'county') && (j.parent_id == this.currentState.id))).forEach(j => {
                result.push({text: j.name, value: j.id})
            })

            result.sort((a, b) => a.text.localeCompare(b.text))
            return result
        },
        schoolDistrictOptions() {
            const result = []
            if (!this.currentState) {return []}

            this.jurisdictions.filter(j => ((j.type == 'school-district') && (j.parent_id == this.currentState.id))).forEach(j => {
                result.push({text: j.name, value: j.name})
            })

            result.sort((a, b) => a.text.localeCompare(b.text))
            return result
        },
    },
    data() {
        return {
            formData: {
                state: null,
                city: null,
                county: null,
                school_district: null,
            },
            jurisdictions: null,
        }
    },
    mounted() {
        this.getJurisdictions()
    },
    methods: {
        getFormData() {
            const result = []
            if (this.formData.state) {
                result.push(this.formData.state)
            }

            if (this.formData.city && this.cityOptions.find(o => o.value == this.formData.city)) {
                result.push(this.formData.city)
            }

            if (this.formData.county && this.countyOptions.find(o => o.value == this.formData.county)) {
                result.push(this.formData.county)
            }

            if (this.formData.school_district && this.schoolDistrictOptions.find(o => o.value == this.formData.school_district)) {
                result.push(this.formData.school_district)
            }

            return result
        },
        getJurisdictions() {
            this.$store.dispatch('START_LOADING')
            this.$api.get('/admin/tax-engine/jurisdictions').then(resp => {
                this.jurisdictions = resp
                this.$store.dispatch('STOP_LOADING')
            }).catch((errors) => {
                this.$bus.showError(errors.__all__)
                this.$store.dispatch('STOP_LOADING')
            })
        },
    },
}
</script>
